import React, { FC } from "react";
import { useLocale } from "../../contexts/localeContext";
import { TranslationKeys } from "../../contexts/TranslationKeys";
import { MultiSelectOption } from "../../models/MultiSelectOption";
import Label from "../label/label";
import SettingSelectField from "../settingFields/SettingSelectField";

const GeneralMobileTab: FC = () => {
    const { translate } = useLocale();
    const powerOptions: MultiSelectOption[] = [
        { value: '-40', label: '-40dBm' },
        { value: '-20', label: '-20dBm' },
        { value: '-16', label: '-16dBm' },
        { value: '-12', label: '-12dBm' },
        { value: '-8', label: '-8dBm' },
        { value: '-4', label: '-4dBm' },
        { value: '0', label: '0dBm' },
        { value: '2', label: '+2dBm' },
        { value: '3', label: '+3dBm' },
        { value: '4', label: '+4dBm' },
        { value: '5', label: '+5dBm' },
        { value: '6', label: '+6dBm' },
        { value: '7', label: '+7dBm' },
        { value: '8', label: '+8dBm' },
    ];

    return <div className="w-full min-h-screen">
        <div className="flex flex-col py-2">
            <div className="flex flex-row justify-between" id="powerLabel">
                <Label
                    htmlFor="mobileValues.power"
                    className="text-xs text-gray-600 mt-1" required>{translate.byKey(TranslationKeys.power)}:</Label>
            </div>
            <div className="flex flex-row justify-between">
                <SettingSelectField
                    width="w-64"
                    accessor={`mobileValues.power`}
                    options={powerOptions} />
            </div>
        </div>
    </div>
}

export default GeneralMobileTab;